import { createClient } from '@supabase/supabase-js'

// Get Supabase configuration from environment variables or admin-configured localStorage
const getSupabaseUrl = () => {
  // Try environment variable first (production)
  if (process.env.REACT_APP_SUPABASE_URL) {
    return process.env.REACT_APP_SUPABASE_URL;
  }
  
  // Try localStorage (admin setup for development)
  if (typeof window !== 'undefined' && window.localStorage) {
    const savedUrl = localStorage.getItem('supabase_url');
    if (savedUrl) {
      return savedUrl;
    }
  }
  
  // Default application URL
  return 'https://bjhtlokaafsnoscgecct.supabase.co';
};

const getSupabaseAnonKey = () => {
  // Try environment variable first (production)
  if (process.env.REACT_APP_SUPABASE_ANON_KEY) {
    return process.env.REACT_APP_SUPABASE_ANON_KEY;
  }
  
  // Try localStorage (admin setup for development)
  if (typeof window !== 'undefined' && window.localStorage) {
    const savedKey = localStorage.getItem('supabase_anon_key');
    if (savedKey) {
      return savedKey;
    }
  }
  
  // TEMPORARY FALLBACK: Use hardcoded anon key if environment variables fail
  // This ensures the app works in production while we debug the environment variable issue
  return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJqaHRsb2thYWZzbm9zY2dlY2N0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcxODA3NjIsImV4cCI6MjA3Mjc1Njc2Mn0.bTEjV_muPTR0P5GLtVkAvLxfMc4cOi62mRuHb6F5LKI';
};

// Create Supabase client with application-level credentials
let supabase = null;
let supabaseUrl = null;
let supabaseAnonKey = null;

try {
  supabaseUrl = getSupabaseUrl();
  supabaseAnonKey = getSupabaseAnonKey();
  
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  });
} catch (error) {
  console.error('❌ Failed to create Supabase client:', error);
  console.error('Please configure Supabase credentials in admin settings or environment variables');
}

export { supabase, getSupabaseUrl, getSupabaseAnonKey };

// Helper function to check if Supabase is configured
export const isSupabaseConfigured = () => {
  return supabase !== null;
};

// Database table names
export const TABLES = {
  SURVEY_CATEGORIES: 'survey_categories',
  SURVEY_VOTES: 'survey_votes',
  USER_PROFILES: 'user_profiles'
};

// Vote options with values
export const VOTE_OPTIONS = [
  { value: 3, label: 'I would sell my soul to watch this.', emoji: '👹', color: 'text-red-400' },
  { value: 2, label: 'I want to watch this.', emoji: '🔥', color: 'text-orange-400' },
  { value: 1, label: "I'd watch it.", emoji: '👍', color: 'text-yellow-400' },
  { value: 0, label: 'Ehhhh.', emoji: '😐', color: 'text-gray-400' },
  { value: -1, label: 'No thanks.', emoji: '👎', color: 'text-red-600' }
];

export default supabase;
